import _classCallCheck from "/Users/corinne/workspace/corinne/conference-hall/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/corinne/workspace/corinne/conference-hall/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/corinne/workspace/corinne/conference-hall/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/corinne/workspace/corinne/conference-hall/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/Users/corinne/workspace/corinne/conference-hall/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/corinne/workspace/corinne/conference-hall/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/Users/corinne/workspace/corinne/conference-hall/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/Users/corinne/workspace/corinne/conference-hall/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { router as e, selectors as t, actions as r } from "@k-redux-router/core";
import { applyMiddleware as o } from "k-ramel";
import n from "react";
import { inject as s } from "@k-ramel/react";
import u from "prop-types";

function i(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

function c(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {},
        o = Object.keys(r);
    "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
      return Object.getOwnPropertyDescriptor(r, e).enumerable;
    }))), o.forEach(function (t) {
      i(e, t, r[t]);
    });
  }

  return e;
}

function a(e, t) {
  if (null == e) return {};

  var r,
      o,
      n = function (e, t) {
    if (null == e) return {};
    var r,
        o,
        n = {},
        s = Object.keys(e);

    for (o = 0; o < s.length; o++) {
      r = s[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    }

    return n;
  }(e, t);

  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);

    for (o = 0; o < s.length; o++) {
      r = s[o], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
  }

  return n;
}

var l = function l() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var s = n.routes,
      _n$path = n.path,
      u = _n$path === void 0 ? "ui.router" : _n$path,
      _n$getState = n.getState,
      i = _n$getState === void 0 ? function (e) {
    return e.ui.router;
  } : _n$getState,
      _e = e(s, {
    getState: i
  }),
      a = _e.middleware,
      l = _e.reducer,
      d = _e.init;

  return {
    getDriver: function getDriver(e) {
      return c({}, Object.entries(r).reduce(function (t, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            r = _ref2[0],
            o = _ref2[1];

        return c({}, t, _defineProperty({}, r, function () {
          return e.dispatch(o.apply(void 0, arguments));
        }));
      }, {}), Object.entries(t(i)).reduce(function (t, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            r = _ref4[0],
            o = _ref4[1];

        var n = function n() {
          return o(e.getState());
        };

        return ["getRoute", "getPathParam", "getQueryParam", "getParam"].includes(r) && (n = function n() {
          return o.apply(void 0, arguments)(e.getState());
        }), c({}, t, _defineProperty({}, r, n));
      }, {}));
    },
    getReducer: function getReducer() {
      return {
        path: u,
        reducer: l
      };
    },
    getEnhancer: function getEnhancer() {
      return o(a);
    },
    init: function init(e) {
      e.dispatch(d());
    }
  };
};

var d = function d(e, t) {
  return function (r) {
    var o, s;
    return s = o =
    /*#__PURE__*/
    function (_n$Component) {
      _inherits(o, _n$Component);

      function o(r, _o) {
        var _this;

        _classCallCheck(this, o);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(o).call(this, r, _o)), i(_assertThisInitialized(_this), "toShow", function () {
          var r = _this.context.store,
              o = r.drivers.router;
          if (!o.getState() || !o.getResult()) return void console.error("[k-redux-router] | There is no route found in `state.ui.router.result`");

          if (!o.isFound()) {
            var _e2 = t && t.notFound;

            return void _this.setState(function (t) {
              return c({}, t, {
                show: _e2
              });
            });
          }

          var n = [].concat(e);
          var s = o.getCurrentRoute();

          if (t && t.absolute) {
            var _e3 = n.includes(s.code);

            return void (_e3 !== _this.state.show && _this.setState(function (t) {
              return c({}, t, {
                show: _e3
              });
            }));
          }

          var u = n.includes(s.code);

          for (; s && s.parent && !u;) {
            s = o.getRoute(s.parent), u = n.includes(s.code);
          }

          u !== _this.state.show && _this.setState(function (e) {
            return c({}, e, {
              show: u
            });
          });
        }), _this.state = {
          show: !1
        };
        return _this;
      }

      _createClass(o, [{
        key: "componentWillMount",
        value: function componentWillMount() {
          var _this2 = this;

          var e = this.context.store;
          this.unsubscribe = e.subscribe(function () {
            _this2.toShow();
          }), this.toShow();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.unsubscribe();
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.state.show;
          return e ? n.createElement(r, this.props) : null;
        }
      }]);

      return o;
    }(n.Component), i(o, "displayName", function (e) {
      return "router(".concat(e.displayName || e.name || e.constructor && e.constructor.name || "Unknown", ")");
    }(r)), i(o, "contextTypes", {
      store: function store() {
        return null;
      }
    }), s;
  };
};

d.absolute = function (e, t) {
  return d(e, c({}, t, {
    absolute: !0
  }));
}, d.notFound = function (e) {
  return d(void 0, c({}, e, {
    notFound: !0
  }));
};

var h = function h(e) {
  var t = e.href,
      r = e.onClick,
      o = a(e, ["href", "onClick"]),
      s = o.className,
      u = o.children;
  if (void 0 === t) return null;
  var i = "",
      c = t;
  return t.base && (c = t.base), t.compiled && (c = t.compiled(o)), o.query && (i = "?".concat(function (e) {
    return Object.keys(e).map(function (t) {
      return "".concat(encodeURIComponent(t), "=").concat(encodeURIComponent(e[t]));
    }).join("&");
  }(o.query))), c = "".concat(c).concat(i), n.createElement("a", {
    className: s,
    href: c,
    onClick: r
  }, u);
};

h.propTypes = {
  className: u.string,
  children: u.node,
  href: u.oneOfType([u.string, u.shape({
    base: u.string,
    compiled: u.func
  })]),
  onClick: u.func
}, h.defaultProps = {
  className: void 0,
  children: void 0,
  href: void 0,
  onClick: void 0
};
var p = s(function (e, t, _ref5) {
  var r = _ref5.router;
  var o = t.onClick,
      n = t.code,
      s = t.query,
      u = a(t, ["onClick", "code", "query"]);
  return {
    href: u.href || r.getRoute(n) && r.getRoute(n).href,
    onClick: function onClick(e) {
      o && o(e), function (e) {
        return function (e) {
          return !!(e.shiftKey || e.altKey || e.metaKey || e.ctrlKey);
        }(e) || function (e) {
          return e.button && 0 !== e.button;
        }(e) || e.defaultPrevented;
      }(e) || (r.push(n, u, s), e.preventDefault());
    }
  };
})(h);
export { p as Link, d as forRoute, l as router };